module.exports = __webpack_public_path__ + "img/closed.b526c42d.svg";